import "antd/es/icon/style";
import _Icon from "antd/es/icon";
import "antd/es/row/style";
import _Row from "antd/es/row";
import "antd/es/button/style";
import _Button from "antd/es/button";
import "antd/es/pagination/style";
import _Pagination from "antd/es/pagination";
import "antd/es/col/style";
import _Col from "antd/es/col";
import "antd/es/spin/style";
import _Spin from "antd/es/spin";
import "antd/es/tooltip/style";
import _Tooltip from "antd/es/tooltip";
import "antd/es/radio/style";
import _Radio from "antd/es/radio";
import "antd/es/message/style";
import _message from "antd/es/message";
import "antd/es/empty/style";
import _Empty from "antd/es/empty";
import "antd/es/checkbox/style";
import _Checkbox from "antd/es/checkbox";
import "antd/es/input/style";
import _Input from "antd/es/input";
import "antd/es/tag/style";
import _Tag from "antd/es/tag";
import "antd/es/tree/style";
import _Tree from "antd/es/tree";
var _excluded = ["id", "title", "selected"];

function _typeof(obj) {
  "@babel/helpers - typeof";

  return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) {
    return typeof obj;
  } : function (obj) {
    return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
  }, _typeof(obj);
}

function _toConsumableArray(arr) {
  return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread();
}

function _nonIterableSpread() {
  throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

function _unsupportedIterableToArray(o, minLen) {
  if (!o) return;
  if (typeof o === "string") return _arrayLikeToArray(o, minLen);
  var n = Object.prototype.toString.call(o).slice(8, -1);
  if (n === "Object" && o.constructor) n = o.constructor.name;
  if (n === "Map" || n === "Set") return Array.from(o);
  if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}

function _iterableToArray(iter) {
  if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}

function _arrayWithoutHoles(arr) {
  if (Array.isArray(arr)) return _arrayLikeToArray(arr);
}

function _arrayLikeToArray(arr, len) {
  if (len == null || len > arr.length) len = arr.length;

  for (var i = 0, arr2 = new Array(len); i < len; i++) {
    arr2[i] = arr[i];
  }

  return arr2;
}

function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    enumerableOnly && (symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    })), keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = null != arguments[i] ? arguments[i] : {};
    i % 2 ? ownKeys(Object(source), !0).forEach(function (key) {
      _defineProperty(target, key, source[key]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) {
      Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
  }

  return target;
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

function _objectWithoutProperties(source, excluded) {
  if (source == null) return {};

  var target = _objectWithoutPropertiesLoose(source, excluded);

  var key, i;

  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);

    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
      target[key] = source[key];
    }
  }

  return target;
}

function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _defineProperties(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, descriptor.key, descriptor);
  }
}

function _createClass(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties(Constructor, staticProps);
  Object.defineProperty(Constructor, "prototype", {
    writable: false
  });
  return Constructor;
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function");
  }

  Object.defineProperty(subClass, "prototype", {
    value: Object.create(superClass && superClass.prototype, {
      constructor: {
        value: subClass,
        writable: true,
        configurable: true
      }
    }),
    writable: false
  });
  if (superClass) _setPrototypeOf(subClass, superClass);
}

function _setPrototypeOf(o, p) {
  _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
    o.__proto__ = p;
    return o;
  };

  return _setPrototypeOf(o, p);
}

function _createSuper(Derived) {
  var hasNativeReflectConstruct = _isNativeReflectConstruct();

  return function _createSuperInternal() {
    var Super = _getPrototypeOf(Derived),
        result;

    if (hasNativeReflectConstruct) {
      var NewTarget = _getPrototypeOf(this).constructor;

      result = Reflect.construct(Super, arguments, NewTarget);
    } else {
      result = Super.apply(this, arguments);
    }

    return _possibleConstructorReturn(this, result);
  };
}

function _possibleConstructorReturn(self, call) {
  if (call && (_typeof(call) === "object" || typeof call === "function")) {
    return call;
  } else if (call !== void 0) {
    throw new TypeError("Derived constructors may only return object or undefined");
  }

  return _assertThisInitialized(self);
}

function _assertThisInitialized(self) {
  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return self;
}

function _isNativeReflectConstruct() {
  if (typeof Reflect === "undefined" || !Reflect.construct) return false;
  if (Reflect.construct.sham) return false;
  if (typeof Proxy === "function") return true;

  try {
    Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {}));
    return true;
  } catch (e) {
    return false;
  }
}

function _getPrototypeOf(o) {
  _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
    return o.__proto__ || Object.getPrototypeOf(o);
  };
  return _getPrototypeOf(o);
}
/* eslint-disable no-script-url */

/* eslint-disable jsx-a11y/anchor-is-valid */


import React from 'react';
import classnames from 'classnames';
import './index.less';
import ajax, { extend } from '../sui/ajax';
import UserNode from './user';
var TreeNode = _Tree.TreeNode;
var CheckableTag = _Tag.CheckableTag;
var Search = _Input.Search;
/**
 * 人员选择组件
 */

var SuiPersonnel = /*#__PURE__*/function (_React$Component) {
  _inherits(SuiPersonnel, _React$Component);

  var _super = _createSuper(SuiPersonnel);

  function SuiPersonnel(_props) {
    var _this;

    _classCallCheck(this, SuiPersonnel);

    _this = _super.call(this, _props);

    _this.getAllTreeNodes = function (node) {
      if (!node) {
        return _this.allNodes;
      }

      if (node === true) {
        return _this.lastNodes;
      }

      var index = _this.props.keyIndexPrefix + node.props.dataRef.key;

      if (!_this.allNodes[index]) {
        _this.allNodesNumber++;
        _this.allNodes[index] = node;
      }

      if (!_this.lastNodes[index]) {
        _this.lastNodesNumber++;
        _this.lastNodes[index] = node;
      }
    };

    _this.getAllUserNodes = function (node) {
      if (!node) {
        return _this.allUsers;
      }

      if (node === true) {
        return _this.lastUsers;
      }

      var index = _this.props.keyIndexPrefix + node.props.dataRef.key;

      if (!_this.allUsers[index]) {
        _this.allUsersNumber++;
      }

      if (!_this.lastUsers[index]) {
        _this.lastUsersNumber++;
      }

      if (_this.allUsers[index] !== node) {
        _this.allUsers[index] = node;
      }

      if (_this.lastUsers[index] !== node) {
        _this.lastUsers[index] = node;
      }
    };

    _this.renderTreeNodes = function (treeData, searchKeyword, parent) {
      var that = _assertThisInitialized(_this);

      var _this$props = _this.props,
          keyIndexPrefix = _this$props.keyIndexPrefix,
          filterTreeData = _this$props.filterTreeData,
          nodeChildAttr = _this$props.nodeChildAttr,
          parentCheckable = _this$props.parentCheckable,
          showIcon = _this$props.showIcon,
          groupIcon = _this$props.groupIcon,
          leafIcon = _this$props.leafIcon,
          type = _this$props.type,
          checkable = _this$props.checkable;
      var typeIcons = SuiPersonnel.defaultIcons[type];

      var hasUserApi = _this.hasUserApi();

      groupIcon = groupIcon || typeIcons[0];
      leafIcon = leafIcon || typeIcons[1];
      return treeData.map(function (item) {
        that.filterTreeData(item);
        typeof filterTreeData == "function" && filterTreeData(item);
        var keyId = keyIndexPrefix + item.key;
        var isNotLeaf = item.isLeaf !== true;

        var _checkable = (!isNotLeaf || parentCheckable) && checkable !== false && !_this.hasUserApi() && item.checkable !== false;

        var disableCheckbox = item.selected === true || _this.isRadio() && _this.state.targetNodes.length > 0;
        var icon = showIcon ? isNotLeaf ? groupIcon : leafIcon : null;

        if (!item.icon) {
          item.icon = icon;
        }

        if (!showIcon) {
          item.icon = null;
        }

        var id = item.id,
            title = item.title,
            selected = item.selected,
            props = _objectWithoutProperties(item, _excluded);

        if (searchKeyword) {
          title = _this._getSearchTitle(title, searchKeyword);
        }

        if (parent && !item.hasOwnProperty('parent')) {
          item.parent = parent;
        }

        var nodeProps = _objectSpread(_objectSpread({}, props), {}, {
          dataRef: item,
          title: title,
          id: keyId,
          selectable: hasUserApi,
          disableCheckbox: disableCheckbox,
          checkable: _checkable
        });

        _this.getAllTreeNodes({
          props: nodeProps
        });

        return /*#__PURE__*/React.createElement(TreeNode, nodeProps, isNotLeaf && item[nodeChildAttr] && _this.renderTreeNodes(item[nodeChildAttr], searchKeyword, item));
      });
    };

    _this.onLoad = function (loadedKeys, event) {
      var props = event.node.props;

      if (props.checkable && props.checked && props.children && props.children.length) {
        _this.updateCheckedNodes(props.children, false);
      }
    };

    _this.onLoadData = function (treeNode) {
      var nodeChildAttr = _this.props.nodeChildAttr;
      return new Promise(function (resolve) {
        if (treeNode.props[nodeChildAttr]) {
          resolve();
          return;
        }

        _this.getTreeData(treeNode, resolve);
      });
    };

    _this.onSelect = function (selectedKeys, event) {
      var hasUserApi = _this.hasUserApi();

      if (!hasUserApi) {
        return;
      }

      if (!event.selected || _this.selectedOrgNode === event.node) {
        return;
      }

      _this.selectedOrgNode = event.node;

      _this.setState({
        users_page: 1
      });

      _this._getOrgNodeUsers(event.node, 1);
    };

    _this.onExpand = function (expandedKeys, event) {
      console.log("expand", expandedKeys, event);
    };

    _this.onTargetChange = function (event) {
      var _event$target = event.target,
          checked = _event$target.checked,
          value = _event$target.value;
      var selectedTargetKeys = _this.state.selectedTargetKeys;
      var find = selectedTargetKeys.indexOf(value);

      if (find > -1) {
        if (!checked) {
          selectedTargetKeys.splice(find, 1);
        }
      } else {
        if (checked) {
          selectedTargetKeys.push(value);
        }
      }

      _this.setState({
        selectedTargetKeys: _toConsumableArray(selectedTargetKeys)
      });
    };

    _this.onUserCheck = function (value, event) {
      var checked = event.checked,
          node = event.node;

      _this.updateCheckedUsers([node], checked);
    };

    _this.renderTargetNodes = function (treeNodes, selectedTargetKeys, searchKeyword) {
      if (!treeNodes || !treeNodes.length) {
        return _this.emptyNode();
      }

      var _this$props2 = _this.props,
          _this$props2$targetSt = _this$props2.targetStyle,
          targetStyle = _this$props2$targetSt === void 0 ? "block" : _this$props2$targetSt,
          pagination = _this$props2.pagination;

      if (pagination) {
        targetStyle = "block";
      }

      var cls = classnames("sui-personnel-selected-item", "sui-personnel-selected-item-" + targetStyle);
      return treeNodes.map(function (item, index) {
        var _item$props$dataRef = item.props.dataRef,
            title = _item$props$dataRef.title,
            key = _item$props$dataRef.key;
        var checked = selectedTargetKeys && selectedTargetKeys.indexOf(key) > -1;

        var _key = key + index;

        if (searchKeyword) {
          title = _this._getSearchTitle(title, searchKeyword);
        }

        if (targetStyle === 'tag') {
          return /*#__PURE__*/React.createElement(CheckableTag, {
            className: cls,
            checked: checked,
            onChange: function onChange(ckd) {
              return _this.onTargetChange({
                "target": {
                  "checked": ckd,
                  "value": key
                }
              });
            },
            key: _key
          }, title);
        }

        return /*#__PURE__*/React.createElement("a", {
          className: cls,
          key: _key
        }, /*#__PURE__*/React.createElement(_Checkbox, {
          checked: checked,
          onChange: _this.onTargetChange,
          value: key
        }, title));
      });
    };

    _this.renderUserNodes = function (userNodes, selectedKeys, searchKeyword, parent) {
      if (!userNodes || !userNodes.length) {
        return _this.emptyNode();
      }

      var _this$props3 = _this.props,
          filterUserData = _this$props3.filterUserData,
          keyIndexPrefix = _this$props3.keyIndexPrefix;
      var cls = classnames("sui-personnel-selected-item", "sui-personnel-selected-item-block");
      return userNodes.map(function (item, index) {
        _this.filterUserData(item);

        typeof filterUserData === 'function' && filterUserData(item);
        var title = item.title,
            key = item.key,
            _item$selected = item.selected,
            selected = _item$selected === void 0 ? false : _item$selected;
        var keyId = keyIndexPrefix + key;
        var disableCheckbox = selected || _this.targetNodes[keyId] ? true : false || _this.isRadio() && _this.state.targetNodes.length > 0;
        var checked = selectedKeys && selectedKeys.length && selectedKeys.indexOf(key) > -1 || _this.targetNodes[keyId] ? true : false;

        var _key = key + index;

        if (searchKeyword) {
          title = _this._getSearchTitle(title, searchKeyword);
        }

        if (parent && !item.hasOwnProperty('parentOrg')) {
          item.parentOrg = parent;
        }

        return /*#__PURE__*/React.createElement("a", {
          className: cls,
          key: _key
        }, /*#__PURE__*/React.createElement(UserNode, {
          ref: _this.getAllUserNodes,
          id: keyId,
          dataRef: item,
          eventKey: key,
          disableCheckbox: disableCheckbox,
          checked: checked,
          onCheck: _this.onUserCheck,
          title: title
        }));
      });
    };

    _this.onCheck = function (checkedKeys, event) {
      if (_this.isRadio()) {
        _this.updateCheckedNodes([event.node], true, event.checked);
      } else {
        _this.updateCheckedNodes(event.checkedNodes, true);
      }
    };

    _this.addSelected = function () {
      _this.addSelectedNodes();
    };

    _this.removeSelected = function () {
      _this.removeSelectedNodes();
    };

    _this.selectAllUserHanlder = function (e) {
      var checked = e.target.checked ? true : false;

      _this.selectAllUsers(checked);
    };

    _this.selectAllHanlder = function (e) {
      var checked = e.target.checked ? true : false;

      _this.selectAll(checked);
    };

    _this.selectAllTargetHanlder = function (e) {
      var checked = e.target.checked ? true : false;

      _this.selectAllTarget(checked);
    };

    _this.onSearchUserValueChange = function (e) {
      e.persist();
      var value = e.nativeEvent.target.value;
      _this.searchUserValue = value;

      _this.setState({});

      _this.searchUserNodes(value);
    };

    _this.searchUserData = function (value) {
      var keyword = value.trim();
      _this.searchUserValue = keyword;

      _this.setState({
        users_page: 1
      });

      _this._getOrgNodeUsers(_this.selectedOrgNode, 1);
    };

    _this.searchData = function (value) {
      console.log('searchdata', value);
      var keyword = value.trim();
      _this.searchValue = keyword;

      _this.setState({});

      if (_this.hasUserApi() && !_this.props.searchOrg) {
        return;
      }

      if (!keyword) {
        return _this.initTreeData();
      }

      _this.getTreeData();
    };

    _this.onSearchValueChange = function (e) {
      e.persist();
      var value = e.nativeEvent.target.value;
      _this.searchValue = value;

      _this.setState({});

      _this.hasUserApi() && _this.props.searchOrg && _this.searchOrgNodes(value);
    };

    _this.searchTarget = function (value) {
      value = '' + value;
      var keyword = value.trim();
      var nodes = [];
      var currentPage = 1;
      var searchText = '';

      if (keyword) {
        if (!_this.preSearchPage) {
          _this.preSearchPage = _this.state.currentPage;
        }

        nodes = _this.searchTargetNodes(keyword);
        searchText = keyword;
      } else {
        currentPage = _this.preSearchPage;
        _this.preSearchPage = 0;
        nodes = _this.getTargetNodes('nodes');
      }

      _this.searchTargetValue = searchText;

      _this.setState({
        total: nodes.length,
        targetNodes: nodes,
        currentPage: currentPage
      });
    };

    _this.onSearchTargetChange = function (e) {
      e.persist();
      var value = e.nativeEvent.target.value;

      _this.searchTarget(value);
    };

    _this.onPageChange = function (page, pageSize) {
      _this.setState({
        currentPage: page,
        selectedTargetKeys: []
      });
    };

    _this.onUserPageChange = function (page, pageSize) {
      _this.setState({
        users_page: page
      });

      _this._getOrgNodeUsers(_this.selectedOrgNode, page);
    };

    _this.onGroupChange = function (e) {
      var hasUserApi = _this.hasUserApi();

      _this.setState({
        groupId: e.target.value
      });

      _this.currentGroup = e.target.value;

      if (!hasUserApi) {
        _this.initTreeData();
      } else if (_this.selectedOrgNode) {
        _this.setState({
          users_page: 1
        });

        _this._getOrgNodeUsers(_this.selectedOrgNode, 1);
      }
    };

    _this.getRefDOM = function (node) {
      if (node && _this.refDOM !== node) {
        _this.refDOM = node;
      }

      return _this.refDOM;
    };

    _this.getRefInstance = function (node) {
      if (node && _this.refInstance !== node) {
        _this.refInstance = node;
      }

      return _this.refInstance;
    };

    _this.onBlur = function (e) {
      _this.blurHandler(e);
    };

    _this.onFocus = function (e) {
      _this.focusHandler(e);
    };

    _this.state = {
      treeData: _this.props.initTreeData || [],
      checkedKeys: _this.props.checkedKeys || [],
      selectedKeys: [],
      checkedUsersKeys: _this.props.checkedUsersKeys || [],
      selectedUsersKeys: [],
      targetNodes: [],
      selectedTargetKeys: [],
      currentPage: 1,
      total: 0,
      loading: false,
      user_loading: false,
      groupId: _this.props.defaultGroupId || '',
      users_page: _this.props.start_page || 1,
      users_total: 0,
      users_list: []
    };
    _this.currentGroup = _this.state.groupId;
    _this.checkedNodes = {};
    _this.checkedUsers = {};
    _this.targetNodes = {};
    _this.currentTargetNodes = [];
    _this.preSearchPage = 0;
    _this.allNodes = {};
    _this.allNodesNumber = 0;
    _this.lastNodes = {};
    _this.lastNodesNumber = 0;
    _this.lastRequestNodeId = _this.props.initId || '';
    _this.lastRequestOrgNodeId = 0;
    _this.selectedOrgNode = null;
    _this.orgTreeData = {};
    _this.lastUsers = {};
    _this.lastUsersNumber = 0;
    _this.allUsers = {};
    _this.allUsersNumber = 0;
    _this.lastRequestParentId = 0;
    window.userTree = _assertThisInitialized(_this);
    return _this;
  }

  _createClass(SuiPersonnel, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      this.props.treeData || this.initTreeData();
    }
    /**
     * 初始化根节点
     */

  }, {
    key: "initTreeData",
    value: function initTreeData() {
      this.getTreeData(this.props.initId);
    }
    /**
     * 重置树
     * @param {*} data 
     */

  }, {
    key: "resetTreeData",
    value: function resetTreeData(data) {
      this.lastNodes = {};
      this.lastNodesNumber = 0;
      this.checkedNodes = {};
      this.setState({
        treeData: _toConsumableArray(data),
        checkedKeys: [],
        selectedKeys: []
      });
    }
    /**
     * 重置人员列表
     * @param {*} data 
     */

  }, {
    key: "resetUserList",
    value: function resetUserList(data, total) {
      this.lastUsers = {};
      this.lastUsersNumber = 0;
      this.checkedUsers = {};
      this.setState({
        users_list: _toConsumableArray(data),
        users_total: total,
        checkedUsersKeys: [],
        selectedUsersKeys: []
      });
    }
    /**
     * 获取所有树节点
     */

  }, {
    key: "getUserNode",
    value:
    /**
     * 根据key获取人员Node
     * @param {*} userKey 
     */
    function getUserNode(userKey) {
      var index = this.keyIndexPrefix + userKey;
      return this.allUsers[index];
    }
    /**
     * 根据Key获取Node
     * @param {} nodeKey 
     */

  }, {
    key: "getNode",
    value: function getNode(nodeKey) {
      var index = this.keyIndexPrefix + nodeKey;
      return this.allNodes[index];
    }
    /**
     * 读取数据
     * @param {*} key 
     */

  }, {
    key: "parserData",
    value: function parserData(res, key, defaultValue) {
      if (!key) {
        return typeof defaultValue === 'undefined' ? res : defaultValue;
      }

      var keys = key.trim().split(".");
      var data = typeof defaultValue === 'undefined' ? res : defaultValue;

      for (var index = 0; index < keys.length; index++) {
        var k = keys[index];
        data = data[k];

        if (!data && index < keys.length - 1) {
          return defaultValue;
        }
      }

      return data;
    }
    /**
     * 请求获取数据
     * @param {*} node 
     * @param {*} callback 
     */

  }, {
    key: "getTreeData",
    value: function getTreeData(node, callback) {
      if (this.single_load_orgId) {
        return callback();
      }

      var that = this;
      var _this$props4 = this.props,
          nodeKeyAttr = _this$props4.nodeKeyAttr,
          initId = _this$props4.initId,
          orgId = _this$props4.orgId,
          orgIdAttr = _this$props4.orgIdAttr,
          nodeChildAttr = _this$props4.nodeChildAttr,
          groupIdAttr = _this$props4.groupIdAttr,
          groups = _this$props4.groups,
          dataAttr = _this$props4.dataAttr,
          searchKey = _this$props4.searchKey,
          api = _this$props4.api,
          method = _this$props4.method,
          beforeAjax = _this$props4.beforeAjax,
          successAjax = _this$props4.successAjax,
          extraParams = _this$props4.extraParams,
          failAjax = _this$props4.failAjax,
          completeAjax = _this$props4.completeAjax,
          _this$props4$extraAja = _this$props4.extraAjaxSettings,
          extraAjaxSettings = _this$props4$extraAja === void 0 ? {} : _this$props4$extraAja;
      var hasUserApi = this.hasUserApi();
      var isSearch = this.searchValue && this.searchValue.length > 0;
      var nodeId = initId;
      var isTreeNode = _typeof(node) == 'object' && node !== null && node.props && node.props.dataRef;
      var data = {};

      if (isTreeNode) {
        nodeId = node.props.dataRef[nodeKeyAttr];

        if (nodeId !== this.lastRequestNodeId) {
          this.lastRequestNodeId = nodeId;
        }
      } else {
        nodeId = node;
      }

      if (isSearch) {
        data[searchKey] = this.searchValue.trim();
      }

      if (nodeId !== null) {
        data[nodeKeyAttr] = nodeId;
      }

      if (!hasUserApi && groupIdAttr && groups && groups.length && this.currentGroup) {
        data[groupIdAttr] = this.currentGroup;
      }

      var single_load_orgId = hasUserApi && orgId !== null && orgId !== undefined;

      if (single_load_orgId) {
        data[orgIdAttr] = orgId;
      }

      this.single_load_orgId = single_load_orgId;
      typeof beforeAjax === 'function' && beforeAjax.call(this, data, node);
      var state = {};
      state['loading'] = true;
      this.setState(state);
      var params = extend(extraParams, data, true);
      console.log('tree loading...', params);
      ajax(api, Object.assign({
        type: method,
        data: params,
        success: function success(res) {
          typeof successAjax == "function" && successAjax.call(that, res, node);
          var data = that.parserData(res, dataAttr);

          if (!data || !data.length) {
            data = [];
          }

          if (isTreeNode) {
            node.props.dataRef[nodeChildAttr] = _toConsumableArray(data);
            data = that.state.treeData;
            that.setState({
              treeData: _toConsumableArray(that.state.treeData)
            });
          } else {
            that.resetTreeData(data);
          }

          typeof callback == "function" && callback(res, node);
        },
        error: function error(errCode, res) {
          console.log("ajax error:", arguments);
          typeof failAjax === 'function' && failAjax.call(that, errCode, res, node);
        },
        complete: function complete() {
          console.log("ajax complete");
          var state = {};
          state['loading'] = false;
          that.setState(state);
          typeof completeAjax === 'function' && completeAjax.call(that, node);
        }
      }, extraAjaxSettings));
    }
    /**
     * 异步加载人员
     * @param {*} page 
     * @param {*} callback 
     */

  }, {
    key: "loadSelectedOrgUsers",
    value: function loadSelectedOrgUsers(page, callback) {
      var cur = page || 1;
      this.setState({
        users_page: cur
      });

      this._getOrgNodeUsers(this.selectedOrgNode, cur, callback);
    }
    /**
     * 加载机构人员
     * @param {*} node 
     * @param {*} callback 
     */

  }, {
    key: "_getOrgNodeUsers",
    value: function _getOrgNodeUsers(node, page, callback) {
      var that = this;
      var _this$props5 = this.props,
          pagination = _this$props5.pagination,
          rowsAttr = _this$props5.rowsAttr,
          beginAttr = _this$props5.beginAttr,
          pageAttr = _this$props5.pageAttr,
          nodeKeyAttr = _this$props5.nodeKeyAttr,
          userOrgParamAttr = _this$props5.userOrgParamAttr,
          groupIdAttr = _this$props5.groupIdAttr,
          groups = _this$props5.groups,
          dataAttr = _this$props5.dataAttr,
          userSearchKey = _this$props5.userSearchKey,
          userTotalAttr = _this$props5.userTotalAttr,
          user_api = _this$props5.user_api,
          method = _this$props5.method,
          perpage_rows = _this$props5.perpage_rows,
          beforeUserAjax = _this$props5.beforeUserAjax,
          successUserAjax = _this$props5.successUserAjax,
          extraUserParams = _this$props5.extraUserParams,
          failUserAjax = _this$props5.failUserAjax,
          completeUserAjax = _this$props5.completeUserAjax,
          _this$props5$extraUse = _this$props5.extraUserAjaxSettings,
          extraUserAjaxSettings = _this$props5$extraUse === void 0 ? {} : _this$props5$extraUse;
      var nodeId = 0;
      var isTreeNode = _typeof(node) == 'object' && node !== null && node.props && node.props.dataRef;
      var isSearch = this.searchUserValue && this.searchUserValue.length > 0;
      var data = {};

      if (isTreeNode) {
        nodeId = node.props.dataRef[nodeKeyAttr];

        if (nodeId !== this.lastRequestParentId) {
          this.lastRequestParentId = nodeId;
        }
      } else {
        nodeId = node == null ? '' : node;
      }

      if (isSearch) {
        data[userSearchKey] = this.searchUserValue.trim();
      }

      if (nodeId !== null) {
        data[userOrgParamAttr || nodeKeyAttr] = nodeId;
      }

      if (groupIdAttr && groups && groups.length && this.currentGroup) {
        data[groupIdAttr] = this.currentGroup;
      }

      var users_page = page || 1;

      if (pagination) {
        var beginIndex = (users_page - 1) * perpage_rows;

        if (pageAttr) {
          data[pageAttr] = users_page;
        } else {
          data[beginAttr] = beginIndex;
        }

        data[rowsAttr] = perpage_rows;
      }

      typeof beforeUserAjax === 'function' && beforeUserAjax.call(this, data, node);
      var state = {};
      state['user_loading'] = true;
      this.setState(state);
      var params = extend(extraUserParams, data, true);
      ajax(user_api, Object.assign({
        type: method,
        data: params,
        success: function success(res) {
          typeof successUserAjax == "function" && successUserAjax.call(that, res, node);
          var data = that.parserData(res, dataAttr);

          if (!data || !data.length) {
            data = [];
          }

          var total = that.state.users_total || data.length;

          if (userTotalAttr && userTotalAttr.length) {
            var _total = that.parserData(res, userTotalAttr);

            if (users_page === 1) {
              total = _total;
            }
          }

          that.resetUserList(data, total);
          typeof callback == "function" && callback(res, node);
        },
        error: function error(errCode, res) {
          typeof failUserAjax === 'function' && failUserAjax.call(that, errCode, res, node);
        },
        complete: function complete() {
          state['user_loading'] = false;
          that.setState(state);
          typeof completeUserAjax === 'function' && completeUserAjax.call(that, node);
        }
      }, extraUserAjaxSettings));
    }
    /**
     * 过滤节点数据
     * @param {*} treeData 
     */

  }, {
    key: "filterTreeData",
    value: function filterTreeData(treeData) {
      var _this$props6 = this.props,
          nodeKeyAttr = _this$props6.nodeKeyAttr,
          nodeTitleAttr = _this$props6.nodeTitleAttr,
          nodeLeafAttr = _this$props6.nodeLeafAttr,
          nodeCheckableAttr = _this$props6.nodeCheckableAttr;

      if (treeData.__filtered) {
        return treeData;
      }

      if (nodeKeyAttr && treeData.hasOwnProperty(nodeKeyAttr) && !treeData.hasOwnProperty('key')) {
        treeData.key = treeData[nodeKeyAttr];
      }

      if (nodeTitleAttr && treeData.hasOwnProperty(nodeTitleAttr) && !treeData.hasOwnProperty('title')) {
        treeData.title = treeData[nodeTitleAttr];
      }

      if (nodeLeafAttr && treeData.hasOwnProperty(nodeLeafAttr) && !treeData.hasOwnProperty('isLeaf')) {
        treeData.isLeaf = treeData[nodeLeafAttr] ? true : false;
      }

      if (nodeCheckableAttr && treeData.hasOwnProperty(nodeCheckableAttr) && !treeData.hasOwnProperty('checkable')) {
        treeData.checkable = treeData.hasOwnProperty(nodeCheckableAttr) !== false;
      }

      treeData.__filtered = true;
      return treeData;
    }
    /**
     * 判断是否有人员接口
     */

  }, {
    key: "hasUserApi",
    value: function hasUserApi() {
      return this.props.user_api && this.props.user_api.length ? true : false;
    }
    /**
     * 渲染树
     */

  }, {
    key: "updateCheckedKeys",
    value:
    /**
     * 更新选中状态值
     * @param {*} nodes 
     */
    function updateCheckedKeys(checkedNodes) {
      var selectedKeys = [];
      var _checkedKeys = [];

      for (var key in checkedNodes) {
        if (checkedNodes.hasOwnProperty(key)) {
          var node = checkedNodes[key];

          if (!node.props.dataRef.selected) {
            selectedKeys.push(node.props.dataRef.key);
          }

          _checkedKeys.push(node.props.dataRef.key);
        }
      }

      this.setState({
        checkedKeys: [].concat(_checkedKeys),
        selectedKeys: [].concat(selectedKeys)
      });
    }
    /**
     * 已选项的选中状态变化
     */

  }, {
    key: "updateCheckedUsers",
    value:
    /**
     * 更新选中人人员
     * @param {*} nodes
     */
    function updateCheckedUsers(nodes, checked) {
      var keyIndexPrefix = this.props.keyIndexPrefix;

      if (checked) {
        if (this.isRadio()) {
          this.checkedUsers = {};
          this.removeCheckedNodes();
        }
      }

      var checkedUsers = this.checkedUsers;

      if (!nodes) {
        return;
      }

      if (nodes instanceof Array) {
        for (var index = 0; index < nodes.length; index++) {
          var node = nodes[index];
          var key = keyIndexPrefix + node.props.dataRef.key;

          if (checked && node.props.checkable) {
            node.props.dataRef.checked = true;
            checkedUsers[key] = node;
          } else {
            delete checkedUsers[key];
          }
        }
      } else {
        for (var _key in nodes) {
          if (nodes.hasOwnProperty(_key)) {
            var _node = nodes[_key];

            var _key2 = keyIndexPrefix + _node.props.dataRef.key;

            if (checked && _node.props.checkable) {
              _node.props.dataRef.checked = true;
              checkedUsers[_key2] = _node;
            } else {
              delete checkedUsers[_key2];
            }
          }
        }
      }

      this.checkedUsers = checkedUsers;
      this.updateCheckedUsersKeys(checkedUsers);
      return checkedUsers;
    }
    /**
     * 更新选中人员Keys
     * @param {} checkedUsers 
     */

  }, {
    key: "updateCheckedUsersKeys",
    value: function updateCheckedUsersKeys(checkedUsers) {
      var selectedKeys = [];
      var _checkedKeys = [];

      for (var key in checkedUsers) {
        if (checkedUsers.hasOwnProperty(key)) {
          var node = checkedUsers[key];

          if (!node.props.dataRef.selected) {
            selectedKeys.push(node.props.dataRef.key);
          }

          _checkedKeys.push(node.props.dataRef.key);
        }
      }

      this.setState({
        checkedUsersKeys: [].concat(_checkedKeys),
        selectedUsersKeys: [].concat(selectedKeys)
      });
    }
    /**
     * 是否达到限制数量
     */

  }, {
    key: "isMax",
    value: function isMax() {
      var maxLength = this.props.maxLength;
      var _this$state = this.state,
          targetNodes = _this$state.targetNodes,
          checkedUsersKeys = _this$state.checkedUsersKeys,
          checkedKeys = _this$state.checkedKeys;
      var count = targetNodes.length + checkedUsersKeys.length + checkedKeys.length;
      return maxLength > 0 && count >= maxLength;
    }
    /**
     * 单选判断
     */

  }, {
    key: "isRadio",
    value: function isRadio() {
      return this.props.maxLength === 1;
    }
    /**
     * 人员的选中状态变化
     */

  }, {
    key: "_getSearchTitle",
    value:
    /**
     * 搜索标题高亮处理
     * @param {*} title 
     * @param {*} search 
     */
    function _getSearchTitle(title, search) {
      var words = title.split(search);
      var nodes = [];

      for (var index = 0; index < words.length; index++) {
        var text = words[index];
        nodes.push(text);

        if (index < words.length - 1) {
          nodes.push( /*#__PURE__*/React.createElement("span", {
            className: "search-text",
            key: index
          }, search));
        }
      }

      return nodes;
    }
    /**
     * 输出已选项目
     */

  }, {
    key: "filterUserData",
    value:
    /**
     * 过滤人员数据
     * @param {*} userData 
     */
    function filterUserData(userData) {
      var _this$props7 = this.props,
          userKeyAttr = _this$props7.userKeyAttr,
          userTitleAttr = _this$props7.userTitleAttr;

      if (userData.__filtered) {
        return userData;
      }

      if (userKeyAttr && userData.hasOwnProperty(userKeyAttr) && !userData.hasOwnProperty('key')) {
        userData.key = userData[userKeyAttr];
      }

      if (userTitleAttr && userData.hasOwnProperty(userTitleAttr) && !userData.hasOwnProperty('title')) {
        userData.title = userData[userTitleAttr];
      }

      if (!userData.hasOwnProperty('isLeaf')) {
        userData.isLeaf = true;
      }

      userData.__filtered = true;
      return userData;
    }
    /**
     * 输出人员列表
     */

  }, {
    key: "updateCheckedNodes",
    value:
    /**
     * 
     * @param {*} nodes 
     */
    function updateCheckedNodes(nodes, reset, checked) {
      var keyIndexPrefix = this.props.keyIndexPrefix;

      if (this.isRadio()) {
        reset = true;
        this.checkedNodes = {};
        this.removeCheckedUsers();
      }

      var checkedNodes = reset ? {} : this.checkedNodes;

      if (nodes instanceof Array) {
        for (var index = 0; index < nodes.length; index++) {
          var node = nodes[index];

          if (!node.props.checkable) {
            // 忽略不可选项
            continue;
          }

          var key = keyIndexPrefix + node.props.dataRef.key;
          checkedNodes[key] = node;
        }
      } else {
        for (var _key3 in nodes) {
          if (nodes.hasOwnProperty(_key3)) {
            var _node2 = nodes[_key3];

            if (!_node2.props.checkable) {
              // 忽略不可选项
              continue;
            }

            var keyIndex = keyIndexPrefix + _node2.props.dataRef.key;
            checkedNodes[keyIndex] = _node2;
          }
        }
      }

      this.checkedNodes = checkedNodes;
      this.updateCheckedKeys(checkedNodes);
      return checkedNodes;
    }
    /**
     * 反选已选择的节点
     */

  }, {
    key: "removeCheckedNodes",
    value: function removeCheckedNodes() {
      for (var key in this.checkedNodes) {
        if (this.checkedNodes.hasOwnProperty(key)) {
          var node = this.checkedNodes[key];

          if (!node.props.dataRef.selected) {
            delete this.checkedNodes[key];
          }
        }
      }

      this.updateCheckedKeys(this.checkedNodes);
    }
    /**
     * 反选已选择的人员
     */

  }, {
    key: "removeCheckedUsers",
    value: function removeCheckedUsers() {
      for (var key in this.checkedUsers) {
        if (this.checkedUsers.hasOwnProperty(key)) {
          var node = this.checkedUsers[key];

          if (!node.props.dataRef.selected) {
            delete this.checkedUsers[key];
          }
        }
      }

      this.updateCheckedUsersKeys(this.checkedUsers);
    }
    /**
     * checked回调
     */

  }, {
    key: "addSelectedNodes",
    value:
    /**
     * 将已选项目，增加到目标
     */
    function addSelectedNodes() {
      var keyIndexPrefix = this.props.keyIndexPrefix;
      var _this$state2 = this.state,
          selectedKeys = _this$state2.selectedKeys,
          selectedUsersKeys = _this$state2.selectedUsersKeys;

      for (var index = 0; index < selectedKeys.length; index++) {
        var key = selectedKeys[index];
        var keyIndex = keyIndexPrefix + key;

        if (!this.checkedNodes.hasOwnProperty(keyIndex)) {
          continue;
        }

        var node = this.checkedNodes[keyIndex];
        node.props.dataRef.selected = true;
        this.targetNodes[keyIndex] = node;
      }

      for (var _index = 0; _index < selectedUsersKeys.length; _index++) {
        var _key4 = selectedUsersKeys[_index];

        var _keyIndex = keyIndexPrefix + _key4;

        if (!this.checkedUsers.hasOwnProperty(_keyIndex)) {
          continue;
        }

        var _node3 = this.checkedUsers[_keyIndex];
        _node3.props.dataRef.selected = true;
        this.targetNodes[_keyIndex] = _node3;
      }

      var _this$getTargetNodes = this.getTargetNodes(),
          nodes = _this$getTargetNodes.nodes;

      this.searchTargetValue = '';
      this.setState({
        selectedKeys: [],
        selectedUsersKeys: [],
        total: nodes.length,
        targetNodes: nodes
      });
      typeof this.props.onChange == "function" && this.props.onChange.call(this, nodes);
    }
    /**
     * 添加操作
     */

  }, {
    key: "removeChildsNodes",
    value:
    /**
     * 移除子项选中状态
     * @param {*} node 
     */
    function removeChildsNodes(node) {}
    /**
     * 从已选的目标项中移除
     */

  }, {
    key: "removeSelectedNodes",
    value: function removeSelectedNodes() {
      var keyIndexPrefix = this.props.keyIndexPrefix;
      var _this$state3 = this.state,
          selectedTargetKeys = _this$state3.selectedTargetKeys,
          checkedKeys = _this$state3.checkedKeys,
          checkedUsersKeys = _this$state3.checkedUsersKeys;
      var lastNodes = this.getAllTreeNodes(true);
      var lastUsers = this.getAllUserNodes(true);

      for (var index = 0; index < selectedTargetKeys.length; index++) {
        var key = '' + selectedTargetKeys[index];
        var keyIndex = keyIndexPrefix + key;

        if (lastNodes.hasOwnProperty(keyIndex)) {
          lastNodes[keyIndex].props.dataRef.selected = false;
        }

        if (lastUsers.hasOwnProperty(keyIndex)) {
          lastUsers[keyIndex].props.dataRef.selected = false;
        }

        if (this.checkedNodes.hasOwnProperty(keyIndex)) {
          var checkedNode = this.checkedNodes[keyIndex];
          checkedNode.props.dataRef.selected = false;
          delete this.checkedNodes[keyIndex];
        }

        if (this.checkedUsers.hasOwnProperty(keyIndex)) {
          var _checkedNode = this.checkedUsers[keyIndex];
          _checkedNode.props.dataRef.selected = false;
          _checkedNode.props.dataRef.checked = false;
          delete this.checkedUsers[keyIndex];
        }

        if (this.targetNodes.hasOwnProperty(keyIndex)) {
          delete this.targetNodes[keyIndex];
        }

        var findIndex = checkedKeys.indexOf(key);
        findIndex > -1 && checkedKeys.splice(findIndex, 1);
        var findUserIndex = checkedUsersKeys.indexOf(key);
        findUserIndex > -1 && checkedUsersKeys.splice(findUserIndex, 1);
      }

      var _this$getTargetNodes2 = this.getTargetNodes(),
          nodes = _this$getTargetNodes2.nodes;

      this.searchTargetValue = '';
      this.setState({
        total: nodes.length,
        targetNodes: nodes,
        selectedTargetKeys: []
      });
      this.updateCheckedKeys(this.checkedNodes);
      typeof this.props.onChange == "function" && this.props.onChange.call(this, nodes);
    }
    /**
     * 执行移除操作
     */

  }, {
    key: "getTargetNodes",
    value:
    /**
     * 获取所有选中的项目
     */
    function getTargetNodes(attr) {
      var nodes = [];
      var keys = [];

      for (var key in this.targetNodes) {
        if (this.targetNodes.hasOwnProperty(key)) {
          var node = this.targetNodes[key];
          nodes.push(node);
          keys.push(node.props.dataRef.key);
        }
      }

      var data = {
        nodes: nodes,
        keys: keys
      };

      if (typeof attr === 'string' && attr.length) {
        return data[attr];
      }

      return data;
    }
    /**
     * 获取选中人员机构的节点
     */

  }, {
    key: "getTargetParentOrgNodes",
    value: function getTargetParentOrgNodes() {
      var keyIndexPrefix = this.props.keyIndexPrefix;
      var nodes = {};

      for (var key in this.targetNodes) {
        if (this.targetNodes.hasOwnProperty(key)) {
          var node = this.targetNodes[key];

          if (node.props.dataRef.parentOrg && node.props.dataRef.isLeaf) {
            var orgKey = keyIndexPrefix + node.props.dataRef.parentOrg.props.dataRef.key;
            nodes[orgKey] = node.props.dataRef.parentOrg;
          }
        }
      }

      return nodes;
    }
    /**
     * 获取选中人员的父级机构
     */

  }, {
    key: "getTargetParentOrg",
    value: function getTargetParentOrg() {
      var nodes = [];
      var parentOrgNodes = this.getTargetParentOrgNodes();

      for (var key in parentOrgNodes) {
        if (parentOrgNodes.hasOwnProperty(key)) {
          var node = parentOrgNodes[key];
          nodes.push(node);
        }
      }

      return nodes;
    }
    /**
     * 获取当前分页项目
     */

  }, {
    key: "getCurrentTargetNodes",
    value: function getCurrentTargetNodes(targetNodes, currentPage, pageSize) {
      var start = (currentPage - 1) * pageSize;

      if (start < 0) {
        start = 0;
      }

      if (start > targetNodes.length - 1) {
        start = targetNodes.length - 1;
      }

      return targetNodes.slice(start, start + pageSize);
    }
    /**
     * 获取节点数据
     * @param {*} nodes 
     * @param {*} attr 
     * @param {*} filter 
     */

  }, {
    key: "__getNodesData",
    value: function __getNodesData(nodes, attr, filter) {
      var values = [];

      for (var index = 0; index < nodes.length; index++) {
        var node = nodes[index];

        var data = this.__getNodeData(node);

        if (typeof filter === "function" && false === filter(data)) {
          continue;
        }

        if (attr && typeof attr !== "boolean") {
          if (data.hasOwnProperty(attr)) {
            values.push(data[attr]);
          } else if (data.__ref__ && data.__ref__.hasOwnProperty(attr)) {
            values.push(data.__ref__[attr]);
          }
        } else {
          values.push(data);
        }
      }

      return values;
    }
    /**
     * 获取节点数据
     * @param {} node 
     */

  }, {
    key: "__getNodeData",
    value: function __getNodeData(node) {
      var _this$props8 = this.props,
          nodeKeyAttr = _this$props8.nodeKeyAttr,
          nodeLeafAttr = _this$props8.nodeLeafAttr,
          nodeTitleAttr = _this$props8.nodeTitleAttr,
          userKeyAttr = _this$props8.userKeyAttr,
          userTitleAttr = _this$props8.userTitleAttr;
      var data = {
        __ref__: {
          title: node.props.title,
          key: node.key || node.props.dataRef.key,
          isLeaf: node.props.isLeaf || false,
          dataRef: node.props.dataRef
        }
      };
      if (userKeyAttr && userKeyAttr !== 'key' && node.props.dataRef.hasOwnProperty(userKeyAttr)) data[userKeyAttr] = node.props.dataRef[userKeyAttr];
      if (userTitleAttr && userTitleAttr !== 'title' && node.props.dataRef.hasOwnProperty(userTitleAttr)) data[userTitleAttr] = node.props.dataRef[userTitleAttr];
      if (nodeKeyAttr && nodeKeyAttr !== 'key' && node.props.dataRef.hasOwnProperty(nodeKeyAttr)) data[nodeKeyAttr] = node.props.dataRef[nodeKeyAttr];
      if (nodeTitleAttr && nodeTitleAttr !== 'title' && node.props.dataRef.hasOwnProperty(nodeTitleAttr)) data[nodeTitleAttr] = node.props.dataRef[nodeTitleAttr];
      if (nodeLeafAttr && nodeLeafAttr !== 'isLeaf' && node.props.dataRef.hasOwnProperty(nodeLeafAttr)) data[nodeLeafAttr] = node.props.dataRef[nodeLeafAttr];
      return data;
    }
    /**
     * 获取选中的节点数据
     */

  }, {
    key: "_getNodesData",
    value: function _getNodesData(attr, filter) {
      return this.__getNodesData(this.state.targetNodes, attr, filter);
    }
    /**
     * 获取选中项中人员的父机构值
     */

  }, {
    key: "getParentOrgValue",
    value: function getParentOrgValue(attr, filter) {
      attr = attr || 'key';
      return this.__getNodesData(this.getTargetParentOrg(), attr, filter);
    }
    /**
     * 获取选中项中人员的父机构值
     */

  }, {
    key: "getParentOrgData",
    value: function getParentOrgData(attr) {
      attr = attr || 'key';
      return this.__getNodesData(this.getTargetParentOrg(), false);
    }
    /**
     * 获取选中项
     */

  }, {
    key: "getLeafsValue",
    value: function getLeafsValue(attr) {
      attr = attr || 'key';
      return this._getNodesData(attr, function (node) {
        return node.__ref__.isLeaf;
      });
    }
    /**
     * 获取选中非叶子节点
     */

  }, {
    key: "getParentsValue",
    value: function getParentsValue(attr) {
      attr = attr || 'key';
      return this._getNodesData(attr, function (node) {
        return !node.__ref__.isLeaf;
      });
    }
    /**
     * 获取选中项
     */

  }, {
    key: "getValue",
    value: function getValue(attr) {
      attr = attr || 'key';
      return this._getNodesData(attr);
    }
    /**
     * 获取完整数据值
     */

  }, {
    key: "getData",
    value: function getData() {
      return this._getNodesData();
    }
    /**
     * 获取选中的子节点数据
     */

  }, {
    key: "getLeafsData",
    value: function getLeafsData() {
      return this._getNodesData(false, function (node) {
        return node.__ref__.isLeaf;
      });
    }
    /**
     * 获取选中项
     */

  }, {
    key: "getParentsData",
    value: function getParentsData() {
      return this._getNodesData(false, function (node) {
        return !node.__ref__.isLeaf;
      });
    }
    /**
     * 全选人员
     * @param {*} selected 
     */

  }, {
    key: "selectAllUsers",
    value: function selectAllUsers(selected) {
      if (selected === false) {
        this.removeCheckedUsers();
      } else {
        this.updateCheckedUsers(this.getAllUserNodes(true), true);
      }
    }
    /**
     * 全选
     * @param {} selected 
     */

  }, {
    key: "selectAll",
    value: function selectAll(selected) {
      if (selected === false) {
        this.removeCheckedNodes();
      } else {
        this.updateCheckedNodes(this.getAllTreeNodes(true));
      }
    }
    /**
     * 全选目标项目
     * @param {} selected 
     */

  }, {
    key: "selectAllTarget",
    value: function selectAllTarget(selected) {
      if (selected === false) {
        return this.setState({
          selectedTargetKeys: []
        });
      }

      this.setState({
        selectedTargetKeys: this.currentTargetNodes.map(function (node) {
          return node.props.dataRef.key;
        })
      });
    }
    /**
     * 全选当前人员列表
     */

  }, {
    key: "emptyNode",
    value:
    /**
     * 空占位
     */
    function emptyNode(text) {
      var txt = text || this.props.emptyText;
      return /*#__PURE__*/React.createElement(_Empty, {
        description: txt,
        image: _Empty.PRESENTED_IMAGE_SIMPLE
      });
    }
    /**
     * 全选目标选项
     */

  }, {
    key: "searchUserNodes",
    value:
    /**
     * 搜索人员
     * @param {*} value 
     */
    function searchUserNodes(value) {
      value = '' + value;
      var keyword = value.trim();
      var reg = new RegExp("(" + keyword + ")", "img");
      var nodes = [];
      var allUsers = this.getAllUserNodes();
      var selectedUsersKeys = [];
      var checkedUsersKeys = [];

      for (var key in allUsers) {
        if (allUsers.hasOwnProperty(key)) {
          var node = allUsers[key];

          if (reg.test(node.props.title) || reg.test(node.props.dataRef.title) || reg.test('' + node.props.dataRef.key)) {
            nodes.push(node.props.dataRef);
            node.props.checked && !node.props.dataRef.selected && selectedUsersKeys.push(node.props.dataRef.key);
          }
        }
      }

      this.setState({
        users_list: [].concat(nodes),
        selectedUsersKeys: selectedUsersKeys,
        checkedUsersKeys: checkedUsersKeys
      });
    }
    /**
     * 执行人员搜索
     * @param {} value 
     */

  }, {
    key: "searchUserData",
    value: function searchUserData(value) {
      var keyword = value.trim();
      this.searchUserValue = keyword;

      if (this.selectedOrgNode) {
        this.setState({
          users_page: 1
        });

        this._getOrgNodeUsers(this.selectedOrgNode, 1);
      } else {
        _message.warning('请选择右边的机构');
      }

      this.setState({});
    }
    /**
     * 人员搜索值变化
     */

  }, {
    key: "searchOrgNodes",
    value:
    /**
     * 搜索机构
     * @param {*} value 
     */
    function searchOrgNodes(value) {
      value = '' + value;
      var keyword = value.trim();
      var reg = new RegExp("(" + keyword + ")", "img");
      var nodes = [];
      var allNodes = this.getAllTreeNodes();
      var selectedKeys = [];
      var checkedKeys = [];

      for (var key in allNodes) {
        if (allNodes.hasOwnProperty(key)) {
          var node = allNodes[key];

          if (reg.test(node.props.title) || reg.test(node.props.dataRef.title) || reg.test('' + node.props.dataRef.key)) {
            nodes.push(node.props.dataRef);
            node.props.checked && checkedKeys.push(node.props.dataRef.key);
            node.props.checked && !node.props.dataRef.selected && selectedKeys.push(node.props.dataRef.key);
          }
        }
      }

      this.setState({
        treeData: [].concat(nodes),
        selectedKeys: selectedKeys,
        checkedKeys: checkedKeys
      });
    }
    /**
     * 执行搜索
     */

  }, {
    key: "searchTargetNodes",
    value:
    /**
     * 执行搜索
     */
    function searchTargetNodes(value) {
      var nodes = [];
      var keyword = value.trim();

      if (!keyword) {
        return nodes;
      }

      for (var key in this.targetNodes) {
        if (this.targetNodes.hasOwnProperty(key)) {
          var node = this.targetNodes[key];
          var reg = new RegExp("(" + value + ")", "img");

          if (reg.test(node.props.title) || reg.test(node.props.dataRef.title) || reg.test('' + node.props.dataRef.key)) {
            nodes.push(node);
          }
        }
      }

      return nodes;
    }
    /**
     * 目标中搜索
     */

  }, {
    key: "getGroups",
    value: function getGroups() {
      var _this$props9 = this.props,
          groups = _this$props9.groups,
          groupIdAttr = _this$props9.groupIdAttr,
          groupNameAttr = _this$props9.groupNameAttr;
      var groupId = this.state.groupId;

      if (!groups || !groups.length || groupId === undefined) {
        return '';
      }

      var radios = groups.map(function (group, index) {
        var key = group[groupIdAttr];
        var title = group[groupNameAttr];
        return /*#__PURE__*/React.createElement(_Radio.Button, {
          value: key,
          key: index
        }, title);
      });
      return /*#__PURE__*/React.createElement(_Radio.Group, {
        value: groupId,
        onChange: this.onGroupChange
      }, radios);
    } // 获取组件容器DOM

  }, {
    key: "focus",
    value: function focus() {
      this.getRefInstance().focus();
    }
  }, {
    key: "blur",
    value: function blur() {
      this.getRefInstance().blur();
    }
  }, {
    key: "doRender",
    value: function doRender() {
      var _this$props10 = this.props,
          disabled = _this$props10.disabled,
          blockNode = _this$props10.blockNode,
          showLine = _this$props10.showLine,
          showIcon = _this$props10.showIcon,
          targetStyle = _this$props10.targetStyle,
          showSelectAll = _this$props10.showSelectAll,
          showOrgSelectAll = _this$props10.showOrgSelectAll,
          selectAllText = _this$props10.selectAllText,
          pagination = _this$props10.pagination,
          pageSize = _this$props10.pageSize,
          search = _this$props10.search,
          searchOrg = _this$props10.searchOrg,
          searchText = _this$props10.searchText,
          searchTip = _this$props10.searchTip,
          searchOrgTip = _this$props10.searchOrgTip,
          checkRelated = _this$props10.checkRelated,
          perpage_rows = _this$props10.perpage_rows,
          groups = _this$props10.groups,
          orgHeadTitle = _this$props10.orgHeadTitle;
      var _this$state4 = this.state,
          treeData = _this$state4.treeData,
          selectedKeys = _this$state4.selectedKeys,
          checkedKeys = _this$state4.checkedKeys,
          selectedUsersKeys = _this$state4.selectedUsersKeys,
          checkedUsersKeys = _this$state4.checkedUsersKeys,
          targetNodes = _this$state4.targetNodes,
          selectedTargetKeys = _this$state4.selectedTargetKeys,
          loading = _this$state4.loading,
          user_loading = _this$state4.user_loading,
          currentPage = _this$state4.currentPage,
          total = _this$state4.total,
          users_total = _this$state4.users_total,
          users_list = _this$state4.users_list,
          users_page = _this$state4.users_page;
      var hasUserApi = this.hasUserApi();

      if (pagination) {
        targetStyle = "block";
      }

      var cls = classnames('sui-personnel sui-personnel-style-' + targetStyle, {
        'sui-personnel-disabled': disabled,
        'sui-personnel-searchable': search,
        'sui-personnel-user-trees': hasUserApi
      });
      var targetCls = classnames('sui-personnel-target', {
        'sui-personnel-target-paginaton': pagination
      });

      if (search) {
        pageSize -= 1;
      }

      var hasPaigis = pagination && pageSize && total > pageSize;
      var hasUserPaigis = pagination && perpage_rows && users_total > perpage_rows;
      var currentTargetNodes = [];

      if (hasPaigis) {
        currentTargetNodes = _toConsumableArray(this.getCurrentTargetNodes(targetNodes, currentPage, pageSize));
      } else {
        currentTargetNodes = _toConsumableArray(targetNodes);
      }

      this.currentTargetNodes = currentTargetNodes;
      var hasGroups = groups && groups.length > 0;
      var showHead = showSelectAll ? true : false;
      var disabledLeft = !selectedKeys || !selectedKeys.length;
      var disabledUser = !hasUserApi || !selectedUsersKeys || !selectedUsersKeys.length;
      var disabledRight = !selectedTargetKeys || !selectedTargetKeys.length;
      var checkedAll = this.lastNodesNumber > 0 && checkedKeys.length === this.lastNodesNumber;
      var checkedAllTarget = selectedTargetKeys && selectedTargetKeys.length > 0 && selectedTargetKeys.length === currentTargetNodes.length;
      var checkedAllUser = this.lastUsersNumber > 0 && checkedUsersKeys.length === this.lastUsersNumber;
      var disabledCheckedAll = checkedAll && disabledLeft || this.isRadio();
      var disabledCheckedAllUser = checkedAllUser && disabledUser || this.isRadio();
      var halfCheckedAllUser = !disabledUser && !checkedAllUser && !this.isRadio();
      var halfCheckedAllTarget = !disabledRight && !checkedAllTarget && !this.isRadio();
      var halfCheckedAll = !disabledLeft && !checkedAll && !this.isRadio();
      var leftSpan = 10;
      var centerSpan = 4;
      var rightSpan = 10;
      var userSpan = 0;

      if (hasUserApi) {
        userSpan = 7;
        leftSpan = 8;
        centerSpan = 2;
        rightSpan = 7;
      }

      var showOrgSearch = search && (!this.hasUserApi() || searchOrg !== false);
      var lcls = classnames('sui-personnel-left', {
        'sui-personnel-disabled-search': !showOrgSearch
      });
      var orgHeadSelectAll = showSelectAll && showOrgSelectAll !== false && !hasUserApi;
      return /*#__PURE__*/React.createElement("div", {
        className: cls
      }, hasGroups ? /*#__PURE__*/React.createElement("div", {
        className: "sui-personnel-groups"
      }, this.getGroups()) : '', /*#__PURE__*/React.createElement(_Row, null, /*#__PURE__*/React.createElement(_Col, {
        span: leftSpan
      }, /*#__PURE__*/React.createElement("div", {
        className: lcls
      }, showHead ? /*#__PURE__*/React.createElement("div", {
        className: "sui-personnel-tree-head"
      }, /*#__PURE__*/React.createElement("div", {
        className: "fl"
      }, orgHeadSelectAll ? /*#__PURE__*/React.createElement(_Checkbox, {
        indeterminate: halfCheckedAll,
        disabled: disabledCheckedAll,
        checked: checkedAll,
        onChange: this.selectAllHanlder
      }, selectAllText) : orgHeadTitle), /*#__PURE__*/React.createElement("div", {
        className: "fr"
      }, orgHeadSelectAll && orgHeadTitle)) : '', /*#__PURE__*/React.createElement(_Spin, {
        spinning: loading
      }, /*#__PURE__*/React.createElement("div", {
        className: "sui-personnel-tree"
      }, showOrgSearch ? /*#__PURE__*/React.createElement(_Tooltip, {
        title: searchOrgTip,
        trigger: "focus"
      }, /*#__PURE__*/React.createElement(Search, {
        value: this.searchValue,
        onChange: this.onSearchValueChange,
        placeholder: searchText,
        onSearch: this.searchData
      })) : '', treeData && treeData.length ? /*#__PURE__*/React.createElement("div", {
        className: "sui-personnel-tree-box sui-personnel-nodes-box"
      }, /*#__PURE__*/React.createElement(_Tree, {
        className: "hide-file-icon",
        ref: this.getRefInstance,
        checkStrictly: !checkRelated,
        checkedKeys: checkedKeys,
        loadData: this.onLoadData,
        blockNode: blockNode,
        showIcon: showIcon,
        showLine: showLine,
        checkable: true,
        onLoad: this.onLoad,
        onSelect: this.onSelect,
        onCheck: this.onCheck,
        onExpand: this.onExpand
      }, this.renderTreeNodes(treeData, this.searchValue))) : this.emptyNode())))), userSpan ? /*#__PURE__*/React.createElement(_Col, {
        span: userSpan
      }, /*#__PURE__*/React.createElement("div", {
        className: "sui-personnel-user"
      }, showHead ? /*#__PURE__*/React.createElement("div", {
        className: "sui-personnel-user-head"
      }, /*#__PURE__*/React.createElement("div", {
        className: "fl"
      }, showSelectAll ? /*#__PURE__*/React.createElement(_Checkbox, {
        indeterminate: halfCheckedAllUser,
        disabled: disabledCheckedAllUser,
        checked: checkedAllUser,
        onChange: this.selectAllUserHanlder
      }, selectAllText) : ''), /*#__PURE__*/React.createElement("div", {
        className: "fr"
      }, this.selectedOrgNode ? this.selectedOrgNode.props.dataRef.title : '')) : '', /*#__PURE__*/React.createElement(_Spin, {
        spinning: user_loading
      }, /*#__PURE__*/React.createElement("div", {
        className: "sui-personnel-user-list"
      }, search ? /*#__PURE__*/React.createElement(_Tooltip, {
        title: searchTip,
        trigger: "focus"
      }, /*#__PURE__*/React.createElement(Search, {
        value: this.searchUserValue,
        onChange: this.onSearchUserValueChange,
        placeholder: searchText,
        onSearch: this.searchUserData
      })) : '', users_list && users_list ? /*#__PURE__*/React.createElement("div", {
        className: "sui-personnel-user-box sui-personnel-nodes-box"
      }, this.renderUserNodes(users_list, checkedUsersKeys, this.searchUserValue, this.selectedOrgNode)) : this.emptyNode(), hasUserPaigis ? /*#__PURE__*/React.createElement(_Pagination, {
        onChange: this.onUserPageChange,
        size: "small",
        showLessItems: true,
        simple: true,
        current: users_page,
        total: users_total
      }) : "")))) : '', /*#__PURE__*/React.createElement(_Col, {
        span: centerSpan
      }, /*#__PURE__*/React.createElement("div", {
        className: "sui-personnel-transfer"
      }, /*#__PURE__*/React.createElement(_Button, {
        type: "primary",
        disabled: disabledLeft && disabledUser,
        onClick: this.addSelected
      }, ">"), /*#__PURE__*/React.createElement(_Button, {
        type: "primary",
        disabled: disabledRight,
        onClick: this.removeSelected
      }, "<"))), /*#__PURE__*/React.createElement(_Col, {
        span: rightSpan
      }, /*#__PURE__*/React.createElement("div", {
        className: "sui-personnel-right"
      }, showHead ? /*#__PURE__*/React.createElement("div", {
        className: "sui-personnel-target-head"
      }, showSelectAll ? /*#__PURE__*/React.createElement(_Checkbox, {
        indeterminate: halfCheckedAllTarget,
        checked: checkedAllTarget,
        onChange: this.selectAllTargetHanlder
      }, selectAllText) : '') : '', /*#__PURE__*/React.createElement("div", {
        className: targetCls
      }, search ? /*#__PURE__*/React.createElement(Search, {
        placeholder: searchText,
        value: this.searchTargetValue,
        onChange: this.onSearchTargetChange,
        onSearch: this.searchTarget
      }) : '', /*#__PURE__*/React.createElement("div", {
        className: "sui-personnel-target-box sui-personnel-nodes-box"
      }, this.renderTargetNodes(currentTargetNodes, selectedTargetKeys, this.searchTargetValue)), hasPaigis ? /*#__PURE__*/React.createElement(_Pagination, {
        onChange: this.onPageChange,
        size: "small",
        showLessItems: true,
        simple: true,
        current: currentPage,
        total: total
      }) : "")))));
    }
  }, {
    key: "render",
    value: function render() {
      return this.doRender();
    }
  }]);

  return SuiPersonnel;
}(React.Component);

SuiPersonnel.defaultProps = {
  disabled: false,
  blockNode: true,
  showIcon: true,
  showLine: false,
  checkRelated: true,
  showSelectAll: true,
  showOrgSelectAll: true,
  api: '',
  // 加载节点接口
  user_api: '',
  // 加载人员API
  selectAllText: '全选',
  nodeKeyAttr: 'key',
  nodeChildAttr: 'children',
  nodeTitleAttr: 'title',
  nodeLeafAttr: "isLeaf",
  nodeCheckableAttr: "checkable",
  userKeyAttr: 'key',
  userTitleAttr: 'title',
  userSearchKey: 'title',
  method: "GET",
  parentCheckable: true,
  checkable: true,
  orgId: null,
  orgIdAttr: 'orgId',
  initId: 0,
  keyIndexPrefix: "node-",
  targetStyle: "block",
  groupIcon: null,
  leafIcon: null,
  type: "user",
  pagination: true,
  pageSize: 11,
  emptyText: '暂无数据',
  search: true,
  searchText: '请输入关键词查找',
  searchKey: 'keyword',
  searchTip: "实时本地搜索，回车远程搜索",
  searchOrg: false,
  searchOrgTip: "实时本地搜索，回车远程搜索",
  dataAttr: 'data',
  userDataAttr: 'data',
  userTotalAttr: 'total',
  extraParams: {},
  extraUserParams: {},
  extraAjaxSettings: {},
  extraUserAjaxSettings: {},
  groups: [],
  groupIdAttr: 'groupId',
  groupNameAttr: 'groupName',
  defaultGroupId: '',
  defaultOrgTreeTitle: '选择机构',
  perpage_rows: 10,
  start_page: 1,
  beginAttr: 'beginIndex',
  rowsAttr: 'rows',
  pageAttr: '',
  maxLength: 0,
  orgHeadTitle: '人员机构'
};
SuiPersonnel.defaultIcons = {
  "user": [/*#__PURE__*/React.createElement(_Icon, {
    type: "team"
  }), /*#__PURE__*/React.createElement(_Icon, {
    type: "user"
  })],
  "file": [/*#__PURE__*/React.createElement(_Icon, {
    type: "folder"
  }), /*#__PURE__*/React.createElement(_Icon, {
    type: "file"
  })]
};
export default SuiPersonnel;